"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSuburbStateDto = instanceOfSuburbStateDto;
exports.SuburbStateDtoFromJSON = SuburbStateDtoFromJSON;
exports.SuburbStateDtoFromJSONTyped = SuburbStateDtoFromJSONTyped;
exports.SuburbStateDtoToJSON = SuburbStateDtoToJSON;
exports.SuburbStateDtoToJSONTyped = SuburbStateDtoToJSONTyped;
/**
 * Check if a given object implements the SuburbStateDto interface.
 */
function instanceOfSuburbStateDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('abbreviation' in value) || value['abbreviation'] === undefined)
        return false;
    return true;
}
function SuburbStateDtoFromJSON(json) {
    return SuburbStateDtoFromJSONTyped(json, false);
}
function SuburbStateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'abbreviation': json['abbreviation'],
    };
}
function SuburbStateDtoToJSON(json) {
    return SuburbStateDtoToJSONTyped(json, false);
}
function SuburbStateDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'abbreviation': value['abbreviation'],
    };
}
